<template >
  <div class="auth-container is-flex justify-center align-center hero-section" :style="heroStyle">
    <div class="auth-form-img" style="width: 750px;">
      <!--img style="max-height:210px;height: 100%;" src="@/assets/kmrt-logo.png"-->
      <br>
      <!--mg style="max-height:430px;height: 100%;" src="@/assets/kmrt-train.jpg"-->
    </div>
    <div class="auth-form">
      <el-card>
        <login-form></login-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/Login/Form.vue';
export default {
  components: {
    LoginForm,
  },
  data() {
    return {
      // For Vite-based projects (Vue 3)
      backgroundImagePath: require('@/assets/kmrt/KMRT_logo.png'),
      // For Webpack-based projects (Vue CLI)
      // backgroundImagePath: require('../assets/hero-bg.jpg')
    };
  },
  computed: {
    heroStyle() {
      return {
        backgroundImage: `url(${this.backgroundImagePath})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      };
    },
  },
};
</script>

<style lang="stylus" scoped>
.auth-container
  height 100%
.auth-form
  max-width 550px
  width 100%
.auth-form-img
  text-align: center
.no-border
  border-width 0

@media screen and (max-width: 800px) {
  .auth-form-img {
    display: none;
  }
}

.hero-section {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}
</style>
